"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const env_config_1 = __importDefault(require("../env.config"));
const fetchClient_1 = require("../utils/misc/fetchClient");
const slrConfiguration_1 = require("../dataLayer/apisWithoutCache/slr/slrConfiguration");
function useGetEssentialDataAndTranslations(theme) {
    const [translations, setTranslations] = (0, react_1.useState)(null);
    const [countries, setCountries] = (0, react_1.useState)([]);
    const [cities, setCities] = (0, react_1.useState)([]);
    const [ssoConf, setConf] = (0, react_1.useState)(null);
    const getEssentialData = () => __awaiter(this, void 0, void 0, function* () {
        const countriesPromise = (0, fetchClient_1.__getApiClient)(env_config_1.default.API_URL_CLIENT + `/countries/phone-codes`)
            .then((res) => {
            setCountries(res);
        });
        const citiesPromise = (0, fetchClient_1.__getApiClient)(env_config_1.default.API_URL_CLIENT + `/cities?fields=id,name_english`)
            .then((res) => {
            setCities(res['items']);
        });
        const ssoConfiguration = (0, slrConfiguration_1.ssoConfigurations)().then(res => setConf(res));
        yield Promise.all([countriesPromise, citiesPromise, ssoConfiguration]);
    });
    (0, react_1.useEffect)(() => {
        try {
            const translations = require(`../translations/${theme.locale}`);
            setTranslations(translations === null || translations === void 0 ? void 0 : translations.default);
        }
        catch (error) {
            console.error('error while importing translation', error);
            setTranslations(null);
        }
        getEssentialData().catch((e) => {
            console.log('e->', e.message);
        });
    }, [theme.locale]);
    return { translations, countries, cities, ssoConf };
}
exports.default = useGetEssentialDataAndTranslations;
